module.exports = __webpack_public_path__ + "static/media/upload.a7a3304a.svg";